class AdvertButton {
  start() {
    const buttonsMore = document.querySelectorAll('.advert-button .advert-button-more');
    buttonsMore.forEach((item) => {
      item.addEventListener('click', openModal);
    });
    const buttonsClose = document.querySelectorAll('#ad-modal .ad-modal-close');
    buttonsClose.forEach((item) => {
      item.addEventListener('click', closeModal);
    });
    const buttonsCopyId = document.querySelectorAll('#ad-modal #advert-id-copy');
    buttonsCopyId.forEach((item) => {
      item.addEventListener('click', copyId);
    });
    const buttonsLink = document.querySelectorAll('#ad-modal #advert-link');
    buttonsLink.forEach((item) => {
      item.addEventListener('click', onLinkAd);
    });
    const url = new URL(window.location.href);
    const advid = url.searchParams.get('advid');
    if (advid) {
      const buttonMoreWithSameId = document.querySelector(`.advert-button [data-id='${String(advid)}']`);
      if (buttonMoreWithSameId) {
        buttonMoreWithSameId.click();
      }
    }
  }

  update() {
    const advertButtons = document.querySelectorAll('.advert-button');
    if (advertButtons.length > 0) {
      const url = new URL(window.location.href);
      const advid = url.searchParams.get('advid');
      if (advid) {
        const buttonMoreWithSameId = document.querySelector(`.advert-button [data-id='${String(advid)}']`);
        if (buttonMoreWithSameId) {
          buttonMoreWithSameId.click();
        }
      }
      const buttonsMore = document.querySelectorAll('.advert-button .advert-button-more');
      buttonsMore.forEach((item) => {
        item.removeEventListener('click', openModal);
      });
      const buttonsClose = document.querySelectorAll('#ad-modal .ad-modal-close');
      buttonsClose.forEach((item) => {
        item.removeEventListener('click', closeModal);
      });
      const buttonsCopyId = document.querySelectorAll('#ad-modal #advert-id-copy');
      buttonsCopyId.forEach((item) => {
        item.removeEventListener('click', copyId);
      });
      const buttonsLink = document.querySelectorAll('#ad-modal #advert-link');
      buttonsLink.forEach((item) => {
        item.removeEventListener('click', onLinkAd);
      });
      // add scripts
      buttonsMore.forEach((item) => {
        item.addEventListener('click', openModal);
      });
      buttonsClose.forEach((item) => {
        item.addEventListener('click', closeModal);
      });
      buttonsCopyId.forEach((item) => {
        item.addEventListener('click', copyId);
      });
      buttonsLink.forEach((item) => {
        item.addEventListener('click', onLinkAd);
      });
    }
  }
}

function onLinkAd(e) {
  closeModal(e);
}

function copyId(e) {
  e.preventDefault();
  const buttonId = e.currentTarget;
  const { id } = buttonId.dataset;
  navigator.clipboard.writeText(id)
    .then(() => {
      alert('Информация скопирована');
    })
    .catch(() => {
      alert('Произошла ошибка. Информация не скопирована');
    });
  closeModal(e);
}

function removeURLParameter(url, parameter) {
  const urlparts = url.split('?');
  if (urlparts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`;
    const pars = urlparts[1].split(/[&;]/g);

    for (let i = pars.length; i-- > 0;) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
  }
  return url;
}

function closeModal() {
  const menuBlock = document.querySelector('#ad-modal');
  const url = removeURLParameter(window.location.href, 'advid');
  window.history.pushState({ path: url }, '', url);
  if (Number(menuBlock.dataset.open) === 1) {
    menuBlock.classList.add('advert-button-menu-block_display_none');
    menuBlock.dataset.open = '0';
  }
}

function openModal(e) {
  e.preventDefault();
  const menuBlock = document.querySelector('#ad-modal');
  const buttonMore = e.currentTarget;
  document.querySelector('#advert_advertiser-info-inn').style.display = 'block';
  document.querySelector('#advert_advertiser-info-address').style.display = 'block';
  document.querySelector('#advert-link').style.display = 'flex';

  const url = new URL(window.location.href);
  url.searchParams.set('advid', buttonMore.dataset.id);
  window.history.replaceState(null, null, url.toString());

  if (buttonMore.dataset.advertiser_name) {
    document.querySelector('#advert_advertiser-info-title').textContent = buttonMore.dataset.advertiser_name;
    document.querySelector('#advert-id-copy').dataset.id = buttonMore.dataset.id;

    if (buttonMore.dataset.link) {
      document.querySelector('#advert-link').href = buttonMore.dataset.link;
    } else {
      document.querySelector('#advert-link').style.display = 'none';
    }

    if (buttonMore.dataset.advertiser_inn) {
      document.querySelector('#advert_advertiser-info-inn span').textContent = buttonMore.dataset.advertiser_inn;
    } else {
      document.querySelector('#advert_advertiser-info-inn').style.display = 'none';
    }

    if (buttonMore.dataset.advertiser_address) {
      document.querySelector('#advert_advertiser-info-address span').textContent = buttonMore.dataset.advertiser_address;
    } else {
      document.querySelector('#advert_advertiser-info-address').style.display = 'none';
    }

    menuBlock.addEventListener('click', clickOutside);

    if (Number(menuBlock.dataset.open) === 0) {
      menuBlock.classList.remove('advert-button-menu-block_display_none');
      menuBlock.dataset.open = '1';
    }
  }
}

function clickOutside(e) {
  if (e.target.id === 'ad-modal') {
    closeModal(e);
  }
}

module.exports = AdvertButton;
